import { createReportFreeVariation } from '../../../../shared/mixpanel/events/createReportFreeVariation';
import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_PAGE_NAMES } from '../../../../shared/mixpanel';

const enrichment = {
    [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.CHOOSE_VARIATION,
} as const;

export const reportFreeVariation = createReportFreeVariation('Choose Variation', enrichment);

export { reportAddToFavorites } from './reportAddToFavorites';
export { reportRemoveFromFavorites } from './reportRemoveFromFavorites';
export { reportSellerAvatarClicked } from './reportSellerAvatarClicked';
export { reportPageView } from './reportPageView';
export { reportCustomizeOnDesktop } from './reportCustomizeOnDesktop';
